import { render, staticRenderFns } from "./optionIndex.vue?vue&type=template&id=0a2a51a0"
import script from "./optionIndex.vue?vue&type=script&lang=js"
export * from "./optionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports